module.exports = __WEBPACK_EXTERNAL_MODULE_161__;


//////////////////
// WEBPACK FOOTER
// external "comsMobx"
// module id = 161
// module chunks = 6